import { __rest } from 'tslib';
import React from 'react';
import { PeekInput } from './PeekInput.js';
import { PeekInputAdornment } from './PeekInputAdornment.js';
import { PeekTypography } from './PeekTypography.js';

const PeekCurrencyInput = (_a) => {
    var { field, prefixSymbol = "$" } = _a, props = __rest(_a, ["field", "prefixSymbol"]);
    const onChange = (event) => {
        var _a, _b, _c;
        const value = (_c = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.match(/\d/g)) === null || _c === void 0 ? void 0 : _c.join("");
        const formattedValue = value ? Intl.NumberFormat().format(value) : 0;
        field.onChange({
            target: { name: field.name, value: formattedValue },
        });
    };
    return (React.createElement(PeekInput, Object.assign({}, props, { InputProps: {
            startAdornment: (React.createElement(PeekInputAdornment, { color: "primary", position: "end" },
                React.createElement(PeekTypography, { align: "center", variant: "body2" }, prefixSymbol))),
        }, field: Object.assign(Object.assign({}, field), { onChange, value: (typeof field.value === "number" && Intl.NumberFormat().format(field.value)) || field.value }) })));
};

export { PeekCurrencyInput, PeekCurrencyInput as default };
